import { useState, useEffect } from "react";
import {
  DrawerComponent,
  Modal,
} from "src/components/DialogComponent";
import { useAppDispatch, useAppSelector } from "src/hooks/redux";
import _ from "lodash";
import {
  deleteItemRequest,
  getItemsRequest,
  updateItemRequest,
} from "src/modules/spItems/api";
import { selectCurrentUser, selectUsers } from "src/modules/users/selector";
import Form from "src/components/Form";
import {
  selectGetItemStatus,
  selectItem,
  selectItems,
} from "src/modules/spItems/selectors";
import {
  myTasksDependListName,
  myTasksLocationsListName,
} from "src/api/config/myTasksLists.config";
import { clearItem, getItem, getItems } from "src/modules/spItems/actions";
import moment from "moment";
import {
  myTaskIncCommentsFilesListName,
  myTaskIncCommentsListName,
  myTasksIncidentCardRecipientsListName,
  myTasksIncidentsQuestionsListName,
  myTasksIncidentstListName,
  myTasksTypeIncidentsListName,
} from "src/api/config/myTasksInc.config";
import {
  emailsSender,
  equipmentsListName,
  paramsListName,
  siteUrl,
} from "src/api/config";
import {
  myTasks5WayListName,
  myTasksSDCA5WayListName,
} from "src/api/config/myTasks5Way.config";
import { useNavigate, useSearchParams } from "react-router-dom";
import { FlexCol, FlexRow } from "src/utils/flexLayouts";
import Statuses from "./components/statuses";
import { TooltipItem } from "src/utils/Tooltip";
import { CancelIcon } from "src/components/ui-icons/myTasks/cancel";
import TGButton from "src/components/ui/TGButton";
import { myTaskActionsListName } from "src/api/config/myTasksActions.config";
import Loading from "src/components/Loading";
import LoadingOpBg from "src/components/LoadingOpBg";
import Button from "src/components/Button";
import { RootState } from "src/store/rootReducer";
import { DownloadWithHoverIcon } from "src/components/ui-icons/upload/DownloadIcon";
import { Letter } from "src/components/ui-icons/myTasks/letter";
import html2canvas from "html2canvas";
import PptxGenJS from "pptxgenjs";
import {
  downloadOutlookEmailWithAttachments,
  urlDefault
} from "src/constants";
import { emailAPI } from "src/utils/api.utils";
import {
  incStatus,
  incTrigger,
  incTypes,
  nTrigger,
} from "src/api/config/systemSwitch";
import Trash from "src/components/ui-icons/buttons/Trash";
import { UserAvatar } from "src/components/ui/avatar/Avatar";
import { addUsers } from "src/modules/users/actions";
import { LetterFinish } from "src/components/ui-icons/myTasks/letterFinish";
import { createIncidentPresentation, EquipmentClassification, SimpleClassificationRow } from "./constants/config";
const { sendEmail } = emailAPI();

const IncidentCard = ({
  zIndex,
  open,
  setOpen,
  incidentID,
}: {
  zIndex: number;
  open: boolean;
  setOpen: any;
  incidentID: number;
}) => {
  const dispatch = useAppDispatch();
  const currentUser: any = useAppSelector((state) => selectCurrentUser(state));
  const [fields, setFields] = useState<any>([]);
  const [dependenceFields, setDependenceFields] = useState<any>({
    Location: null,
    Department: null,
    Region: null,
  });
  const [formData, setFormData] = useState<any>(null);
  const [defaultValues, setDefaultValues] = useState<any>({});
  const [customLoading, setCustomLoading] = useState(true);
  const [incQuestions, setIncQuestions] = useState<any>([]);
  const locations: any = useAppSelector((state) =>
    selectItems(state, myTasksLocationsListName)
  );
  const dependencies: any = useAppSelector((state) =>
    selectItems(state, myTasksDependListName)
  );
  const typesIncList: any = useAppSelector((state) =>
    selectItems(state, myTasksTypeIncidentsListName)
  );
  const incCard: any = useAppSelector((state) =>
    selectItem(state, myTasksIncidentstListName)
  );
  const incCardStatus = useAppSelector((state) =>
    selectGetItemStatus(state, myTasksIncidentstListName)
  );
  const users: any = useAppSelector(selectUsers);
  const [checkLoadUsers, setCheckLoadUsers] = useState(false);
  const [renderInc, setRenderInc] = useState(false);
  const [getInc, setGetInc] = useState(false);
  const [currentFormData, setCurrentFormData] = useState<any>(null);
  const [typesInc, setTypesInc] = useState<any>([]);
  const [currentTypeInc, setCurrentTypeInc] = useState<any>(null);
  const [incKeys, setIncKeys] = useState<any>([]);
  const navigate = useNavigate();
  const [ID5Way, setID5Way] = useState(0);
  const [card5WayTree, setCard5WayTree] = useState<any>([]);
  const params: any = useAppSelector((state) =>
    selectItems(state, paramsListName)
  );
  const [cancelModal, setCancelModal] = useState(false);
  const [removeModal, setRemoveModal] = useState(false);
  const [returnToWorkModal, setReturnToWorkModal] = useState(false);
  const [invCompletedModal, setInvCompletedModal] = useState(false);
  const [pptxLoading, setPptxLoading] = useState(false);
  const statusUsers: string = useAppSelector(
    (state: RootState) => state.users.status
  );
  const [modalEml, setModalEml] = useState(false);
  const [loadingEml, setLoadingEml] = useState(false);
  const [titleEmlPptx, setTitleEmlPptx] = useState("");
  const [incCardQuestionsEml, setIncCardQuestionsEml] = useState<any>(null);
  const [actionsEml, setActionsEml] = useState<any>([]);
  const [query, setQuery] = useSearchParams();
  const [keySifTypeEml, setKeySifTypeEml] = useState<any>(null);
  const [keyInjuryTypeEml, setKeyInjuryTypeEml] = useState<any>(null);

  useEffect(() => {
    return () => {
      dispatch(clearItem({ listName: myTasksIncidentstListName }));
    };
  }, []);

  //Расставляем опции селектов локации, типа сотрудников
  useEffect(() => {
    if (currentUser.id && renderInc) {
      const tempFieldsForm = [...fields];
      for (let i = 0; i < tempFieldsForm.length; i++) {
        if (tempFieldsForm[i]["key"] === "Location") {
          const options = locations.filter((location: any) => {
            if (
              currentUser.isAdmin ||
              (currentUser.isLocationEditorMyTasks &&
                currentUser.isLocationEditorMyTasks.length > 0 &&
                currentUser.isLocationEditorMyTasks.find(
                  (locationID: any) => locationID === location.ID
                )) ||
              (currentUser.isLocationAdminMyTasks &&
                currentUser.isLocationAdminMyTasks.length > 0 &&
                currentUser.isLocationAdminMyTasks.find(
                  (locationID: any) => locationID === location.ID
                ))
            ) {
              return true
            } else {
              return false
            }
          }).map((location: any) => {
            return {
              id: location.ID,
              name: location.Title,
              available: true,
            };
          });
          tempFieldsForm[i]["options"] = [...options];
        }
        if (tempFieldsForm[i]["key"] === "TypeIncident") {
          tempFieldsForm[i]["optionsInputs"] =
            typesInc.map((type: any) => type.Title.trim()) || [];
        }
      }
      setFields([...tempFieldsForm]);
    }
  }, [locations, currentUser, renderInc, typesInc]);

  useEffect(() => {
    if (typesIncList.length > 0) {
      setTypesInc(
        typesIncList.filter((type: any) => type.ID !== incTypes.security)
      );
    }
  }, [typesIncList]);

  useEffect(() => {
    if (dependenceFields["Location"] && renderInc) {
      dispatch(
        getItems({
          listName: myTasksDependListName,
          filters: { Location: dependenceFields["Location"]["id"] },
        })
      );
      const tempFieldsForm = [...fields];
      for (let i = 0; i < tempFieldsForm.length; i++) {
        if (tempFieldsForm[i]["key"] === "Department") {
          tempFieldsForm[i]["disabled"] = false;
        }
        if (tempFieldsForm[i]["key"] === "Region") {
          tempFieldsForm[i]["disabled"] = true;
        }
      }
      setFields([...tempFieldsForm]);
    }
    if (!dependenceFields["Location"] && renderInc) {
      const tempFieldsForm = [...fields];
      for (let i = 0; i < tempFieldsForm.length; i++) {
        if (
          tempFieldsForm[i]["key"] === "Department" ||
          tempFieldsForm[i]["key"] === "Region"
        ) {
          tempFieldsForm[i]["disabled"] = true;
        }
      }
      setFields([...tempFieldsForm]);
    }
    if (dependenceFields["Department"] && renderInc) {
      const tempFieldsForm = [...fields];
      for (let i = 0; i < tempFieldsForm.length; i++) {
        if (tempFieldsForm[i]["key"] === "Region") {
          tempFieldsForm[i]["disabled"] = false;
        }
      }
      setFields([...tempFieldsForm]);
    }
  }, [dependenceFields, renderInc]);

  useEffect(() => {
    if (renderInc) {
      const tempFieldsForm = [...fields];
      for (let i = 0; i < tempFieldsForm.length; i++) {
        if (dependenceFields["Location"]) {
          if (tempFieldsForm[i]["key"] === "Department") {
            const options = dependencies
              .filter(
                (dependence: any) =>
                  dependence.Location.ID === dependenceFields["Location"]["id"]
              )
              .map((dependence: any) => {
                return {
                  id: dependence.Departament.ID,
                  name: dependence.Departament.Title,
                };
              });
            tempFieldsForm[i]["options"] = _.uniqWith(options, _.isEqual);
          }
        }
        if (dependenceFields["Department"]) {
          if (tempFieldsForm[i]["key"] === "Region") {
            const options = dependencies
              .filter(
                (dependence: any) =>
                  dependence.Location.ID ===
                  dependenceFields["Location"]["id"] &&
                  dependence.Departament.ID ===
                  dependenceFields["Department"]["id"]
              )
              .map((dependence: any) => {
                return {
                  id: dependence.Region.ID,
                  name: dependence.Region.Title,
                };
              });
            tempFieldsForm[i]["options"] = _.uniqWith(options, _.isEqual);
          }
        }
      }
      setFields([...tempFieldsForm]);
    }
  }, [dependencies, renderInc]);

  useEffect(() => {
    if (formData && Object.keys(formData).length > 0) {
      setCustomLoading(true);
      let tempIncObj: any = {};
      Object.keys(formData).map((key) => {
        if (incKeys.some((incKey: string) => incKey === key)) {
          if (Array.isArray(formData[key])) {
            if (
              formData[key].some(
                (item) =>
                  typeof item === "object" && item.hasOwnProperty("SAP_MESSAGE")
              )
            ) {
              formData[key].sort((a: any, b: any) => {
                return a.SAP_MESSAGE.localeCompare(b.SAP_MESSAGE);
              });
            } else if (
              formData[key].some(
                (item) =>
                  typeof item === "object" && item.hasOwnProperty("name")
              )
            ) {
              formData[key].sort((a: any, b: any) => {
                return a.name.localeCompare(b.name);
              });
            } else if (
              formData[key].some(
                (item) =>
                  typeof item === "object" && item.hasOwnProperty("email")
              )
            ) {
              formData[key].sort((a: any, b: any) => {
                return a.email.localeCompare(b.email);
              });
            } else if (
              formData[key].some(
                (item) => typeof item === "object" && item.hasOwnProperty("SAP")
              )
            ) {
              formData[key].sort((a: any, b: any) => {
                return a.SAP.SAP.localeCompare(b.SAP.SAP);
              });
            } else {
              formData[key].sort((a: any, b: any) => {
                return a.localeCompare(b);
              });
            }
          }
          tempIncObj[key] = formData[key];
        }
      });
      const idCurrentTypeInc = typesInc.filter(
        (type: any) => type.Title === currentTypeInc
      )[0]["ID"];
      let closedDate =
        (typeof formData.DateIncidents.startDate === "string" &&
          new Date(formData.DateIncidents.startDate)) ||
        formData.DateIncidents.startDate;
      if (formData.IncidentOption === "Инцидент") {
        if (idCurrentTypeInc === incTypes.safe) {
          //Безопасность
          const days = Number(
            params
              .find((param: any) => param.Key === "IncSafeDate")
            ["Value"].trim()
          );
          closedDate = moment(closedDate).add(days, "days").toDate();
        }
        if (idCurrentTypeInc === incTypes.e) {
          //Экология
          const days = Number(
            params
              .find((param: any) => param.Key === "IncEnvDate")
            ["Value"].trim()
          );
          closedDate = moment(closedDate).add(days, "days").toDate();
        }
        if (idCurrentTypeInc === incTypes.q) {
          //Качество
          if (formData.QAIncidentType === "Инцидент по качеству") {
            const days = Number(
              params
                .find((param: any) => param.Key === "IncQualityDate")
              ["Value"].trim()
            );
            closedDate = moment(closedDate).add(days, "days").toDate();
          }
          if (formData.QAIncidentType === "Инцидент в процессе") {
            const days = Number(
              params
                .find((param: any) => param.Key === "IncProcessDate")
              ["Value"].trim()
            );
            closedDate = moment(closedDate).add(days, "days").toDate();
          }
        }
        if (idCurrentTypeInc === incTypes.m) {
          //Техобслуживание
          const days = Number(
            params
              .find((param: any) => param.Key === "IncMDate")
            ["Value"].trim()
          );
          closedDate = moment(closedDate).add(days, "days").toDate();
        }
      }
      if (formData.IncidentOption === "Несоответствие") {
        if (idCurrentTypeInc === incTypes.safe) {
          //Безопасность
          const days = Number(
            params
              .find((param: any) => param.Key === "NSafeDate")
            ["Value"].trim()
          );
          closedDate = moment(closedDate).add(days, "days").toDate();
        }
        if (idCurrentTypeInc === incTypes.e) {
          //Экология
          const days = Number(
            params
              .find((param: any) => param.Key === "NEnvDate")
            ["Value"].trim()
          );
          closedDate = moment(closedDate).add(days, "days").toDate();
        }
        if (idCurrentTypeInc === incTypes.q) {
          //Качество
          const days = Number(
            params
              .find((param: any) => param.Key === "NQualityDate")
            ["Value"].trim()
          );
          closedDate = moment(closedDate).add(days, "days").toDate();
        }
        if (idCurrentTypeInc === incTypes.m) {
          //Техобслуживание
          const days = Number(
            params.find((param: any) => param.Key === "NMDate")["Value"].trim()
          );
          closedDate = moment(closedDate).add(days, "days").toDate();
        }
      }
      const sendData = {
        ID: incidentID,
        Questions: JSON.stringify(tempIncObj),
        TypeIncident: idCurrentTypeInc,
        TimeIncident: formData.TimeIncident,
        Responsible: formData.Responsible[0]["value"],
        ResponsibleEmail: formData.Responsible[0]["value"],
        Title: `${formData.IncidentOption}. ${formData.TypeIncident}.${(formData.QAIncidentType && ` ${formData.QAIncidentType}.`) || ""
          } От ${moment(
            (typeof formData.DateIncidents.startDate === "string" &&
              new Date(formData.DateIncidents.startDate)) ||
            formData.DateIncidents.startDate
          ).format("DD.MM.YYYY")}`,
        DateIncidents:
          (typeof formData.DateIncidents.startDate === "string" &&
            new Date(formData.DateIncidents.startDate)) ||
          formData.DateIncidents.startDate,
        DateIncidents2:
          (typeof formData.DateIncidents2.startDate === "string" &&
            new Date(formData.DateIncidents2.startDate)) ||
          formData.DateIncidents2.startDate,
        Location: formData.Location.id,
        Department: formData.Department.id,
        Region: formData.Region.id,
        Description: formData.Description.trim() + " ",
        ClosedDate: closedDate,
        ResponsibleDepartment:
          (users[formData.Responsible[0]["value"]] &&
            users[formData.Responsible[0]["value"]]["department"]) ||
          "",
        Fixed:
          formData.FixedField && formData.FixedField.id === "Да" ? true : false,
      };
      // console.log('update_sendData: ', sendData);
      updateItemRequest({ listName: myTasksIncidentstListName, body: sendData })
        .then((value: any) => {
          const updateIncID = value[0];
          getItemsRequest({
            listName: myTasks5WayListName,
            filters: { Incident: updateIncID },
          }).then((results) => {
            if (results.items.length > 0) {
              const card5WayID = results.items[0]["ID"];
              let trigger: any;
              if (formData.TypeIncident) {
                if (idCurrentTypeInc === incTypes.safe) {
                  if (formData.IncidentOption === "Инцидент") {
                    trigger = incTrigger.safe;
                  }
                  if (formData.IncidentOption === "Несоответствие") {
                    trigger = nTrigger.safe;
                  }
                }
                if (idCurrentTypeInc === incTypes.e) {
                  if (formData.IncidentOption === "Инцидент") {
                    trigger = incTrigger.e;
                  }
                  if (formData.IncidentOption === "Несоответствие") {
                    trigger = nTrigger.e;
                  }
                }
                if (idCurrentTypeInc === incTypes.q) {
                  if (formData.IncidentOption === "Инцидент") {
                    if (formData.QAIncidentType === "Инцидент в процессе") {
                      trigger = incTrigger.process;
                    }
                    if (formData.QAIncidentType === "Инцидент по качеству") {
                      trigger = incTrigger.q;
                    }
                  }
                  if (formData.IncidentOption === "Несоответствие") {
                    trigger = nTrigger.q;
                  }
                }
                if (idCurrentTypeInc === incTypes.m) {
                  if (formData.IncidentOption === "Инцидент") {
                    trigger = incTrigger.m;
                  }
                  if (formData.IncidentOption === "Несоответствие") {
                    trigger = nTrigger.m;
                  }
                }
              }
              const sendData5Way = {
                ID: card5WayID,
                Location: formData.Location.id,
                Department: formData.Department.id,
                Region: formData.Region.id,
                Trigger: trigger,
              };
              updateItemRequest({
                listName: myTasks5WayListName,
                body: sendData5Way,
              }).then(() => {
                if (formData.IncidentOption === "Несоответствие") {
                  getItemsRequest({
                    listName: myTaskActionsListName,
                    filters: {
                      ImportantHashTag: `#${JSON.parse(incCard.Questions)["IncidentOption"]
                        }_${incCard["TypeIncident"]["Title"]}_${incCard.ID
                        }*`.toLowerCase(),
                    },
                  }).then((results) => {
                    const actions = [...results.items];
                    if (actions.length > 0) {
                      let updateDataActions: any = [];
                      actions.map((action) => {
                        let newDesc: any = "";
                        if (action.Description) {
                          newDesc = action.Description.replaceAll(
                            `#${JSON.parse(incCard.Questions)["IncidentOption"]
                              }_${incCard["TypeIncident"]["Title"]}`
                              .toLowerCase()
                              .trim(),
                            `#${formData["IncidentOption"]}_${formData["TypeIncident"]}`
                              .toLowerCase()
                              .trim()
                          );
                        }
                        updateDataActions = [
                          ...updateDataActions,
                          {
                            ID: action.ID,
                            Description: newDesc || action.Description,
                            ImportantHashTag:
                              `#${formData["IncidentOption"]}_${formData["TypeIncident"]}_${incCard.ID}`
                                .toLowerCase()
                                .trim(),
                          },
                        ];
                      });
                      if (updateDataActions.length > 0) {
                        updateItemRequest({
                          listName: myTaskActionsListName,
                          body: updateDataActions[0],
                          bodyArr: updateDataActions,
                        }).then(() => {
                          setGetInc(!getInc);
                          setCustomLoading(false);
                        });
                      }
                    } else {
                      setGetInc(!getInc);
                      setCustomLoading(false);
                    }
                  });
                } else {
                  setGetInc(!getInc);
                  setCustomLoading(false);
                }
              });
            } else {
              if (formData.IncidentOption === "Несоответствие") {
                getItemsRequest({
                  listName: myTaskActionsListName,
                  filters: {
                    ImportantHashTag: `#${JSON.parse(incCard.Questions)["IncidentOption"]
                      }_${incCard["TypeIncident"]["Title"]}_${incCard.ID
                      }*`.toLowerCase(),
                  },
                }).then((results) => {
                  const actions = [...results.items];
                  if (actions.length > 0) {
                    let updateDataActions: any = [];
                    actions.map((action) => {
                      updateDataActions = [
                        ...updateDataActions,
                        {
                          ID: action.ID,
                          Description:
                            action.Description &&
                            action.Description.replace(
                              `#${JSON.parse(incCard.Questions)["IncidentOption"]
                                }_${incCard["TypeIncident"]["Title"]}`
                                .toLowerCase()
                                .trim(),
                              `#${formData["IncidentOption"]}_${formData["TypeIncident"]}`
                                .toLowerCase()
                                .trim()
                            ),
                          ImportantHashTag:
                            `#${formData["IncidentOption"]}_${formData["TypeIncident"]}_${incCard.ID}`
                              .toLowerCase()
                              .trim(),
                        },
                      ];
                    });
                    if (updateDataActions.length > 0) {
                      updateItemRequest({
                        listName: myTaskActionsListName,
                        body: updateDataActions[0],
                        bodyArr: updateDataActions,
                      }).then(() => {
                        if (localStorage.getItem("OpenAdd5WayCardForm")) {
                          localStorage.setItem("OpenAdd5WayCardForm", "");
                          let trigger: any;
                          if (formData.TypeIncident) {
                            const idCurrentTypeInc = typesInc.filter(
                              (type: any) =>
                                type.Title === formData.TypeIncident
                            )[0]["ID"];
                            if (idCurrentTypeInc === incTypes.safe) {
                              if (formData.IncidentOption === "Инцидент") {
                                trigger = {
                                  name: "Инцидент по Безопасности",
                                  id: incTrigger.safe,
                                };
                              }
                              if (
                                formData.IncidentOption === "Несоответствие"
                              ) {
                                trigger = {
                                  name: "Несоответствие по Безопасности",
                                  id: nTrigger.safe,
                                };
                              }
                            }
                            if (idCurrentTypeInc === incTypes.e) {
                              if (formData.IncidentOption === "Инцидент") {
                                trigger = {
                                  name: "Инцидент по Экологии",
                                  id: incTrigger.e,
                                };
                              }
                              if (
                                formData.IncidentOption === "Несоответствие"
                              ) {
                                trigger = {
                                  name: "Несоответствие по Экологии",
                                  id: nTrigger.e,
                                };
                              }
                            }
                            if (idCurrentTypeInc === incTypes.q) {
                              if (formData.IncidentOption === "Инцидент") {
                                if (
                                  formData.QAIncidentType ===
                                  "Инцидент в процессе"
                                ) {
                                  trigger = {
                                    name: "Инцидент в процессе",
                                    id: incTrigger.process,
                                  };
                                }
                                if (
                                  formData.QAIncidentType ===
                                  "Инцидент по качеству"
                                ) {
                                  trigger = {
                                    name: "Инцидент по Качеству",
                                    id: incTrigger.q,
                                  };
                                }
                              }
                              if (
                                formData.IncidentOption === "Несоответствие"
                              ) {
                                trigger = {
                                  name: "Несоответствие по Качеству",
                                  id: nTrigger.q,
                                };
                              }
                            }
                            if (idCurrentTypeInc === incTypes.m) {
                              if (formData.IncidentOption === "Инцидент") {
                                trigger = {
                                  name: "Инцидент по Техобслуживанию",
                                  id: incTrigger.m,
                                };
                              }
                              if (
                                formData.IncidentOption === "Несоответствие"
                              ) {
                                trigger = {
                                  name: "Несоответствие по Техобслуживанию",
                                  id: nTrigger.m,
                                };
                              }
                            }
                          }
                          localStorage.setItem(
                            "default5WayCardDataInc",
                            JSON.stringify({
                              Location: formData.Location,
                              Department: formData.Department,
                              Region: formData.Region,
                              Trigger: trigger,
                            })
                          );
                          localStorage.setItem("NEW_INC", String(incidentID));
                          setCustomLoading(false);
                          if (
                            formData.IncidentOption &&
                            formData.IncidentOption === "Инцидент"
                          ) {
                            navigate("/dashboard/3/deviation-reports");
                          }
                          if (
                            formData.IncidentOption &&
                            formData.IncidentOption === "Несоответствие"
                          ) {
                            navigate("/dashboard/3/5-whys");
                          }
                        } else {
                          setGetInc(!getInc);
                          setCustomLoading(false);
                        }
                      });
                    }
                  } else {
                    if (localStorage.getItem("OpenAdd5WayCardForm")) {
                      localStorage.setItem("OpenAdd5WayCardForm", "");
                      let trigger: any;
                      if (formData.TypeIncident) {
                        const idCurrentTypeInc = typesInc.filter(
                          (type: any) => type.Title === formData.TypeIncident
                        )[0]["ID"];
                        if (idCurrentTypeInc === incTypes.safe) {
                          if (formData.IncidentOption === "Инцидент") {
                            trigger = {
                              name: "Инцидент по Безопасности",
                              id: incTrigger.safe,
                            };
                          }
                          if (formData.IncidentOption === "Несоответствие") {
                            trigger = {
                              name: "Несоответствие по Безопасности",
                              id: nTrigger.safe,
                            };
                          }
                        }
                        if (idCurrentTypeInc === incTypes.e) {
                          if (formData.IncidentOption === "Инцидент") {
                            trigger = {
                              name: "Инцидент по Экологии",
                              id: incTrigger.e,
                            };
                          }
                          if (formData.IncidentOption === "Несоответствие") {
                            trigger = {
                              name: "Несоответствие по Экологии",
                              id: nTrigger.e,
                            };
                          }
                        }
                        if (idCurrentTypeInc === incTypes.q) {
                          if (formData.IncidentOption === "Инцидент") {
                            if (
                              formData.QAIncidentType === "Инцидент в процессе"
                            ) {
                              trigger = {
                                name: "Инцидент в процессе",
                                id: incTrigger.process,
                              };
                            }
                            if (
                              formData.QAIncidentType === "Инцидент по качеству"
                            ) {
                              trigger = {
                                name: "Инцидент по Качеству",
                                id: incTrigger.q,
                              };
                            }
                          }
                          if (formData.IncidentOption === "Несоответствие") {
                            trigger = {
                              name: "Несоответствие по Качеству",
                              id: nTrigger.q,
                            };
                          }
                        }
                        if (idCurrentTypeInc === incTypes.m) {
                          if (formData.IncidentOption === "Инцидент") {
                            trigger = {
                              name: "Инцидент по Техобслуживанию",
                              id: incTrigger.m,
                            };
                          }
                          if (formData.IncidentOption === "Несоответствие") {
                            trigger = {
                              name: "Несоответствие по Техобслуживанию",
                              id: nTrigger.m,
                            };
                          }
                        }
                      }
                      localStorage.setItem(
                        "default5WayCardDataInc",
                        JSON.stringify({
                          Location: formData.Location,
                          Department: formData.Department,
                          Region: formData.Region,
                          Trigger: trigger,
                        })
                      );
                      localStorage.setItem("NEW_INC", String(incidentID));
                      setCustomLoading(false);
                      if (
                        formData.IncidentOption &&
                        formData.IncidentOption === "Инцидент"
                      ) {
                        navigate("/dashboard/3/deviation-reports");
                      }
                      if (
                        formData.IncidentOption &&
                        formData.IncidentOption === "Несоответствие"
                      ) {
                        navigate("/dashboard/3/5-whys");
                      }
                    } else {
                      setGetInc(!getInc);
                      setCustomLoading(false);
                    }
                  }
                });
              } else {
                if (localStorage.getItem("OpenAdd5WayCardForm")) {
                  localStorage.setItem("OpenAdd5WayCardForm", "");
                  let trigger: any;
                  if (formData.TypeIncident) {
                    const idCurrentTypeInc = typesInc.filter(
                      (type: any) => type.Title === formData.TypeIncident
                    )[0]["ID"];
                    if (idCurrentTypeInc === incTypes.safe) {
                      if (formData.IncidentOption === "Инцидент") {
                        trigger = {
                          name: "Инцидент по Безопасности",
                          id: incTrigger.safe,
                        };
                      }
                      if (formData.IncidentOption === "Несоответствие") {
                        trigger = {
                          name: "Несоответствие по Безопасности",
                          id: nTrigger.safe,
                        };
                      }
                    }
                    if (idCurrentTypeInc === incTypes.e) {
                      if (formData.IncidentOption === "Инцидент") {
                        trigger = {
                          name: "Инцидент по Экологии",
                          id: incTrigger.e,
                        };
                      }
                      if (formData.IncidentOption === "Несоответствие") {
                        trigger = {
                          name: "Несоответствие по Экологии",
                          id: nTrigger.safe,
                        };
                      }
                    }
                    if (idCurrentTypeInc === incTypes.q) {
                      if (formData.IncidentOption === "Инцидент") {
                        if (formData.QAIncidentType === "Инцидент в процессе") {
                          trigger = {
                            name: "Инцидент в процессе",
                            id: incTrigger.process,
                          };
                        }
                        if (
                          formData.QAIncidentType === "Инцидент по качеству"
                        ) {
                          trigger = {
                            name: "Инцидент по Качеству",
                            id: incTrigger.q,
                          };
                        }
                      }
                      if (formData.IncidentOption === "Несоответствие") {
                        trigger = {
                          name: "Несоответствие по Качеству",
                          id: nTrigger.q,
                        };
                      }
                    }
                    if (idCurrentTypeInc === incTypes.m) {
                      if (formData.IncidentOption === "Инцидент") {
                        trigger = {
                          name: "Инцидент по Техобслуживанию",
                          id: incTrigger.m,
                        };
                      }
                      if (formData.IncidentOption === "Несоответствие") {
                        trigger = {
                          name: "Несоответствие по Техобслуживанию",
                          id: nTrigger.m,
                        };
                      }
                    }
                  }
                  localStorage.setItem(
                    "default5WayCardDataInc",
                    JSON.stringify({
                      Location: formData.Location,
                      Department: formData.Department,
                      Region: formData.Region,
                      Trigger: trigger,
                    })
                  );
                  localStorage.setItem("NEW_INC", String(incidentID));
                  setCustomLoading(false);
                  if (
                    formData.IncidentOption &&
                    formData.IncidentOption === "Инцидент"
                  ) {
                    navigate("/dashboard/3/deviation-reports");
                  }
                  if (
                    formData.IncidentOption &&
                    formData.IncidentOption === "Несоответствие"
                  ) {
                    navigate("/dashboard/3/5-whys");
                  }
                } else {
                  setGetInc(!getInc);
                  setCustomLoading(false);
                }
              }
            }
          });
        })
        .catch((error) => {
          console.error("Ошибка:", error);
          setCustomLoading(false);
        });
    } else if (incCardStatus === "SUCCESS") {
      setCustomLoading(false);
    }
  }, [formData]);

  useEffect(() => {
    if (incQuestions.length > 0) {
      setFields([...incQuestions]);
      setRenderInc(true);
    }
  }, [incQuestions]);

  useEffect(() => {
    const tempFieldsForm = [...fields];
    let tempKeys: any = [];
    for (let i = 0; i < tempFieldsForm.length; i++) {
      const field = tempFieldsForm[i];
      if (
        !field.hide &&
        (field.condition ||
          field.key === "IncidentOption" ||
          field.key === "QAIncidentType")
      ) {
        tempKeys = [...tempKeys, field.key];
      }
    }
    setIncKeys([...tempKeys]);
  }, [fields]);

  useEffect(() => {
    if (currentTypeInc && typesInc.length > 0) {
      setRenderInc(false);
      const idCurrentTypeInc = typesInc.filter(
        (type: any) => type.Title === currentTypeInc
      )[0]["ID"];
      setCustomLoading(true);
      getItemsRequest({
        listName: myTasksIncidentsQuestionsListName,
        filters: { TypeIncident: idCurrentTypeInc },
        sortOrder: { name: "Order0", asc: true },
      }).then((results) => {
        const tempIncQuestions = [...results.items];
        let incFieldsForm: any = [];
        incFieldsForm = [
          ...incFieldsForm,
          ...[
            {
              type: "date",
              require: true,
              key: "DateIncidents",
              title: "Дата регистрации несоответствия/инцидента",
              minDate: moment(new Date()).subtract(7, "days").toDate(),
              maxDate: moment(new Date()).toDate(),
              placeholder: "дд.мм.гггг",
              condition: null,
              width: "w-full",
            },
            {
              type: "date",
              require: true,
              key: "DateIncidents2",
              title: "Дата несоответствия/инцидента",
              maxDate: moment(new Date()).toDate(),
              placeholder: "дд.мм.гггг",
              condition: null,
              width: "w-[calc(50%-10px)]",
            },
            {
              type: "time",
              require: false,
              key: "TimeIncident",
              title: "Время несоответствия/инцидента",
              placeholder: "чч:мм",
              condition: null,
              width: "w-[calc(50%-10px)]",
            },
            {
              type: "radio",
              require: true,
              title: "Тип несоответствия/инцидента",
              key: "TypeIncident",
              condition: null,
              width: "w-full",
            },
          ],
        ];
        tempIncQuestions.forEach((item) => {
          if (item.Key === "IncidentOption" || item.Key === "QAIncidentType") {
            incFieldsForm = [
              ...incFieldsForm,
              {
                type: item.TypeQuestion,
                require: item.Require,
                noticeAnswers:
                  (item.NoticeAnswers &&
                    JSON.parse(item.NoticeAnswers).filter(
                      (notice: any) => notice.TypeIncident === currentTypeInc
                    ).length > 0 &&
                    JSON.parse(item.NoticeAnswers).filter(
                      (notice: any) => notice.TypeIncident === currentTypeInc
                    )[0]["Notice"]) ||
                  null,
                notice: item.Notice,
                noticeIcon: (item.Notice && true) || false,
                key: item.Key,
                title: item.Title,
                hide: item.DefaultHide,
                width: item.Width,
                optionsInputs:
                  (item.Options &&
                    item.Options.split(";").map((option) => option.trim())) ||
                  [],
                condition: item.Condition && JSON.parse(item.Condition),
              },
            ];
          }
        });
        incFieldsForm = [
          ...incFieldsForm,
          ...[
            {
              type: "peoplePicker",
              require: true,
              single: true,
              key: "Responsible",
              title: "ФИО инициатора",
              current: false,
              condition: null,
              placeholder: "Введите имя или фамилию",
              width: "w-[calc(50%-10px)]",
            },

            {
              type: "select",
              require: true,
              key: "Location",
              title: "Локация, где произошло несоответствие/инцидент",
              placeholder: "Не выбрано",
              condition: null,
              width: "w-[calc(50%-10px)]",
            },
            {
              type: "select",
              require: true,
              key: "Department",
              title: "Отдел, где произошло несоответствие/инцидент",
              placeholder: "Не выбрано",
              condition: null,
              width: "w-[calc(50%-10px)]",
            },
            {
              type: "select",
              require: true,
              key: "Region",
              title: "Участок, где произошло несоответствие/инцидент",
              placeholder: "Не выбрано",
              condition: null,
              width: "w-[calc(50%-10px)]",
            },
            {
              type: "textArea",
              key: "Description",
              require: true,
              title: "Описание",
              condition: null,
              noticeIcon: true,
              notice: `<span className="w-full"><strong>Что?</strong> (Что случилось, в чем именно проблема?)<br/>
            <strong>Где?</strong> (Где именно проблема в продукте/процессе и где была обнаружена?) <br/>
            <strong>Когда?</strong> (Когда проблема началась, когда была обнаружена?) <br/>
            <strong>Как?</strong> (Есть ли стандарт и соблюдался ли он на момент возникновения проблемы?) <br/>
            <strong>Кто?</strong> (Кто обнаружил проблему?) <br/>
            <strong>Насколько велика проблема?</strong> (Количество затронутого продукта / минуты простоя, риски от проблемы)<span>`,
              placeholder:
                "ЧТО? (Что случилось, в чем именно проблема?) ГДЕ? (Где именно проблема в продукте/процессе и где была обнаружена?) КОГДА? (Когда проблема началась, когда была обнаружена?) КАК? (Есть ли стандарт и соблюдался ли он на момент возникновения проблемы?) КТО? (Кто обнаружил проблему?) НАСКОЛЬКО ВЕЛИКА ПРОБЛЕМА? (Количество затронутого продукта / минуты простоя, риски от проблемы)",
              width: "w-full",
            },
          ],
        ];
        tempIncQuestions.forEach((item) => {
          if (item.Key !== "IncidentOption" && item.Key !== "QAIncidentType") {
            if (item.TypeQuestion === "select") {
              incFieldsForm = [
                ...incFieldsForm,
                {
                  type: item.TypeQuestion,
                  require: item.Require,
                  key: item.Key,
                  title: item.Title,
                  notice: item.Notice,
                  noticeIcon: (item.Notice && true) || false,
                  hide: item.DefaultHide,
                  width: item.Width,
                  placeholder: "Не выбрано",
                  condition: item.Condition && JSON.parse(item.Condition),
                  options:
                    (item.Options &&
                      item.Options.split(";").map((option) => {
                        return {
                          id: option.trim(),
                          name: option.trim(),
                        };
                      })) ||
                    [],
                },
              ];
            } else if (
              item.TypeQuestion === "radio" ||
              item.TypeQuestion === "checkbox"
            ) {
              incFieldsForm = [
                ...incFieldsForm,
                {
                  type: item.TypeQuestion,
                  require: item.Require,
                  key: item.Key,
                  notice: item.Notice,
                  noticeIcon: (item.Notice && true) || false,
                  title: item.Title,
                  hide: item.DefaultHide,
                  width: item.Width,
                  condition: item.Condition && JSON.parse(item.Condition),
                  optionsInputs:
                    (item.Options &&
                      item.Options.split(";").map((option) => option.trim())) ||
                    [],
                },
              ];
            } else if (
              item.TypeQuestion === "number" ||
              item.TypeQuestion === "input" ||
              item.TypeQuestion === "textArea"
            ) {
              incFieldsForm = [
                ...incFieldsForm,
                {
                  type: item.TypeQuestion,
                  require: item.Require,
                  key: item.Key,
                  title: item.Title,
                  disabled: item.Disabled,
                  placeholder: "Введите значение",
                  hide: item.DefaultHide,
                  width: item.Width,
                  notice: item.Notice,
                  noticeIcon: (item.Notice && true) || false,
                  condition: item.Condition && JSON.parse(item.Condition),
                  default: item.Options,
                },
              ];
            } else if (item.TypeQuestion === "repeater") {
              if (idCurrentTypeInc === incTypes.q) {
                //Качество
                incFieldsForm = [
                  ...incFieldsForm,
                  {
                    type: item.TypeQuestion,
                    key: item.Key,
                    hide: item.DefaultHide,
                    notice: item.Notice,
                    noticeIcon: (item.Notice && true) || false,
                    title: item.Title,
                    condition: item.Condition && JSON.parse(item.Condition),
                    fields: [
                      {
                        type: "autocomplete",
                        require: item.Require,
                        title: "SAP № технического места",
                        key: "SAP",
                        placeholder: "Начните вводить SAP",
                        width: item.Width,
                        searchApiField: "SAP",
                        searchApiList: equipmentsListName,
                        searchApiSelectFields:
                          "ID,Title,SAP,Manufacturer,Model,TypeEquipment",
                        searchApiFilterField: "",
                        searchApiFilterFieldValue: "",
                      },
                      {
                        type: "text",
                        title: "Название оборудования",
                        key: "Title",
                        value: "",
                        require: item.Require,
                        width: item.Width,
                      },
                      {
                        type: "text",
                        title: "Производитель оборудования",
                        key: "Manufacturer",
                        value: "",
                        require: item.Require,
                        width: item.Width,
                      },
                      {
                        type: "text",
                        title: "Модель оборудования",
                        key: "Model",
                        value: "",
                        require: item.Require,
                        width: item.Width,
                      },
                      {
                        type: "text",
                        title: "Тип оборудования",
                        key: "TypeEquipment",
                        value: "",
                        require: item.Require,
                        width: item.Width,
                      },
                    ],
                    width: item.Width,
                    require: item.Require,
                  },
                ];
              }
              if (idCurrentTypeInc === incTypes.m) {
                //Техобслуживание
                incFieldsForm = [
                  ...incFieldsForm,
                  {
                    type: item.TypeQuestion,
                    key: item.Key,
                    hide: item.DefaultHide,
                    title: item.Title,
                    notice: item.Notice,
                    noticeIcon: (item.Notice && true) || false,
                    condition: item.Condition && JSON.parse(item.Condition),
                    fields: [
                      {
                        type: "input",
                        key: "SAP_MESSAGE",
                        require: item.Require,
                        title: "SAP номер сообщения",
                        placeholder: "Введите значение",
                        width: item.Width,
                      },
                      {
                        type: "autocomplete",
                        require: item.Require,
                        title: "SAP № технического места",
                        key: "SAP",
                        placeholder: "Начните вводить SAP",
                        width: item.Width,
                        searchApiField: "SAP",
                        searchApiList: equipmentsListName,
                        searchApiSelectFields:
                          "ID,Title,SAP,Manufacturer,Model,TypeEquipment",
                        searchApiFilterField: "",
                        searchApiFilterFieldValue: "",
                      },
                      {
                        type: "text",
                        title: "Название оборудования",
                        key: "Title",
                        value: "",
                        require: item.Require,
                        width: item.Width,
                      },
                      {
                        type: "text",
                        title: "Производитель оборудования",
                        key: "Manufacturer",
                        value: "",
                        require: item.Require,
                        width: item.Width,
                      },
                      {
                        type: "text",
                        title: "Модель оборудования",
                        key: "Model",
                        value: "",
                        require: item.Require,
                        width: item.Width,
                      },
                      {
                        type: "text",
                        title: "Тип оборудования",
                        key: "TypeEquipment",
                        value: "",
                        require: item.Require,
                        width: item.Width,
                      },
                    ],
                    width: item.Width,
                    require: item.Require,
                  },
                ];
              }
            }
          }
        });
        setIncQuestions([...incFieldsForm]);
        setCustomLoading(false);
      });
    } else {
      setRenderInc(true);
    }
  }, [currentTypeInc, typesInc]);

  useEffect(() => {
    if (incidentID) {
      getItemsRequest({ listName: myTasksIncidentstListName, filters: { ID: incidentID } }).then(results => {
        if (results.items.length === 0) {
          alert("Карточка инцидента/несоответствия не найдена или удалена");
          query.delete("incidentCard");
          setQuery(query);
          return;
        } else {
          getItemsRequest({
            listName: myTasks5WayListName,
            filters: { Incident: incidentID },
          }).then((results) => {
            if (results.items.length > 0) {
              const card5WayID = results.items[0]["ID"];
              setID5Way(card5WayID);
              setCard5WayTree(
                (results.items[0].Tree && JSON.parse(results.items[0].Tree)) || []
              );
            }
            dispatch(
              getItem({
                listName: myTasksIncidentstListName,
                filters: { ID: incidentID },
              })
            );
          });
        }
      });
    }
  }, [incidentID, getInc]);

  useEffect(() => {
    if (
      renderInc &&
      incCard &&
      Object.keys(incCard).length > 0 &&
      !checkLoadUsers &&
      Object.keys(users).length > 0
    ) {
      console.log("incCard: ", incCard);
      if (incCard.AuthorEmail && incCard.ResponsibleEmail) {
        if (users[incCard.AuthorEmail] && users[incCard.ResponsibleEmail]) {
          setCheckLoadUsers(true);
        }
      }
      let tempDefaultValues: any = {};
      Object.keys(incCard).map((key: string, idx: number) => {
        const field = incCard[key];
        if (field && key === "Responsible") {
          tempDefaultValues[key] = [
            {
              label:
                (users[field.Email] && users[field.Email].displayName) ||
                field.Name,
              value:
                (users[field.Email] && users[field.Email].email) || field.Email,
              avatar: (users[field.Email] && users[field.Email].avatar) || null,
              email:
                (users[field.Email] && users[field.Email].email) || field.Email,
            },
          ];
        } else if (key === "DateIncidents" || key === "DateIncidents2") {
          tempDefaultValues[key] = {
            startDate: field.toDate(),
            endDate: field.toDate(),
          };
        } else if (
          key === "Location" ||
          key === "Department" ||
          key === "Region" ||
          key === "Status"
        ) {
          tempDefaultValues[key] = {
            id: field.ID,
            name: field.Title,
          };
        } else if (key === "AuthorEmail" || key === "Fixed") {
          return false;
        } else if (key === "Questions") {
          if (field) {
            const incObj = JSON.parse(field);
            if (incObj) {
              tempDefaultValues = { ...tempDefaultValues, ...incObj };
            }
          }
        } else if (key === "TypeIncident") {
          tempDefaultValues[key] = field.Title;
          setCurrentTypeInc(field.Title);
        } else {
          tempDefaultValues[key] = field;
        }
      });
      setDefaultValues((prevState: any) => {
        return { ...prevState, ...tempDefaultValues };
      });
      setCurrentFormData({ ...tempDefaultValues });
    }
  }, [incCard, users, checkLoadUsers, renderInc]);

  useEffect(() => {
    if (
      incCard &&
      Object.keys(incCard).length > 0 &&
      currentUser.id &&
      renderInc &&
      fields.length > 0
    ) {
      const tempFieldsForm = [...fields];
      if (
        incCard.Status.ID === incStatus.finish ||
        incCard.Status.ID === incStatus.cancel ||
        (!currentUser.isAdmin &&
          (!currentUser.isLocationEditorMyTasks ||
            (currentUser.isLocationEditorMyTasks &&
              !currentUser.isLocationEditorMyTasks.some(
                (locationID: number) => locationID === incCard.Location.ID
              ))) &&
          (!currentUser.isLocationAdminMyTasks ||
            (currentUser.isLocationAdminMyTasks &&
              !currentUser.isLocationAdminMyTasks.some(
                (locationID: number) => locationID === incCard.Location.ID
              ))))
      ) {
        for (let i = 0; i < tempFieldsForm.length; i++) {
          tempFieldsForm[i]["disabled"] = true;
        }
      } else {
        for (let i = 0; i < tempFieldsForm.length; i++) {
          tempFieldsForm[i]["disabled"] = incQuestions[i]["disabled"];
        }
      }
      setFields([...tempFieldsForm]);
    }
  }, [incCard, currentUser, renderInc, dependenceFields]);

  useEffect(() => {
    if (renderInc && incCard && Object.keys(incCard).length > 0 && incCard.UserFinished) {
      dispatch(addUsers([incCard.UserFinished]));
    }
  }, [incCard, renderInc]);

  useEffect(() => {
    if (renderInc && currentFormData) {
      const tempFieldsForm = [...fields];
      for (let i = 0; i < tempFieldsForm.length; i++) {
        const field = tempFieldsForm[i];
        if (field.condition) {
          let conditionObj: any = {};
          Object.keys(field.condition).map((key: string) => {
            if (typeof currentFormData[key] === "object") {
              if (currentFormData[key]["name"] === field.condition[key]) {
                conditionObj[key] = true;
              }
            } else {
              if (currentFormData[key] === field.condition[key]) {
                conditionObj[key] = true;
              }
            }
          });
          if (
            Object.keys(field.condition).length ===
            Object.keys(conditionObj).length
          ) {
            tempFieldsForm[i]["hide"] = false;
          } else {
            tempFieldsForm[i]["hide"] = true;
          }
        }
      }
      setFields([...tempFieldsForm]);
    }
  }, [currentFormData, renderInc]);

  const cancelHandle = () => {
    setCancelModal(false);
    setCustomLoading(true);
    updateItemRequest({
      listName: myTasksIncidentstListName,
      body: { ID: incidentID, Status: incStatus.cancel },
    }).then((results) => {
      setCustomLoading(false);
      navigate(0);
    });
  };

  const removeHandle = () => {
    setCustomLoading(true);
    setRemoveModal(false);
    getItemsRequest({
      listName: myTaskIncCommentsListName,
      filters: { Incident: incCard.ID },
    }).then((result) => {
      const commentsInc = [...result.items];
      const commentsIds = commentsInc.map((comment) => comment.ID);
      if (commentsIds.length > 0) {
        getItemsRequest({
          listName: myTaskIncCommentsFilesListName,
          filters: { Comment: commentsIds },
        }).then((result) => {
          const commentsFiles = [...result.items];
          const commetnsFilesIds = commentsFiles.map((file) => {
            return {
              ID: file.ID,
            };
          });
          if (commetnsFilesIds.length > 0) {
            deleteItemRequest({
              listName: myTaskIncCommentsFilesListName,
              ID: 0,
              Ids: commetnsFilesIds,
              fileField: "File",
            }).then(() => {
              const commentsIdsRemove = commentsIds.map((commentID) => {
                return {
                  ID: commentID,
                };
              });
              deleteItemRequest({
                listName: myTaskIncCommentsListName,
                ID: 0,
                Ids: commentsIdsRemove,
              }).then(() => {
                deleteItemRequest({
                  listName: myTasksIncidentstListName,
                  ID: incCard.ID,
                }).then(() => {
                  setCustomLoading(false);
                  setOpen(false);
                  navigate(0);
                });
              });
            });
          } else {
            const commentsIdsRemove = commentsIds.map((commentID) => {
              return {
                ID: commentID,
              };
            });
            deleteItemRequest({
              listName: myTaskIncCommentsListName,
              ID: 0,
              Ids: commentsIdsRemove,
            }).then(() => {
              deleteItemRequest({
                listName: myTasksIncidentstListName,
                ID: incCard.ID,
              }).then(() => {
                setCustomLoading(false);
                setOpen(false);
                navigate(0);
              });
            });
          }
        });
      } else {
        deleteItemRequest({
          listName: myTasksIncidentstListName,
          ID: incCard.ID,
        }).then(() => {
          setCustomLoading(false);
          setOpen(false);
          navigate(0);
        });
      }
    });
  };

  const returnToWorkHandle = (type: any) => {
    setReturnToWorkModal(false);
    setCustomLoading(true);
    updateItemRequest({
      listName: myTasksIncidentstListName,
      body: { ID: incidentID, Status: incStatus.process },
    }).then((results) => {
      if (
        emailsSender &&
        incCard.ResponsibleEmail !== currentUser.email &&
        type === "Инцидент"
      ) {
        const timestamp = moment().unix();
        const emailBody = {
          Body: `Здравствуйте ${users[incCard.ResponsibleEmail] &&
            users[incCard.ResponsibleEmail]["displayName"]
            },<br/><br/>Примите во внимание, что пользователь ${currentUser.displayName
            } вернул в работу инцидент <a href="${siteUrl}${urlDefault}/dashboard/3/incidents-and-nonconformities?incidentCard=${incCard.ID
            }">${incCard.Title.trim()}</a>`,
          DateToBeSentAt: moment().subtract(12, "hours").toDate(),
          Title: "Мои Задачи | Возвращение в работу Инцидента",
          Subject: "Мои Задачи | Возвращение в работу Инцидента",
          Recepients: incCard.ResponsibleEmail,
          CheckDoc: String(timestamp),
        };
        Promise.all([sendEmail(emailBody)]).then(() => {
          setCustomLoading(false);
          navigate(0);
        });
      } else {
        setCustomLoading(false);
        navigate(0);
      }
    });
  };

  const invCompletedHandle = () => {
    setInvCompletedModal(false);
    setCustomLoading(true);
    updateItemRequest({
      listName: myTasksIncidentstListName,
      body: { ID: incidentID, Status: incStatus.finish, UserFinished: currentUser.email, DateFinished: new Date() },
    }).then((results) => {
      if (emailsSender && incCard.ResponsibleEmail !== currentUser.email) {
        const timestamp = moment().unix();
        const emailBody = {
          Body: `Здравствуйте ${users[incCard.ResponsibleEmail] &&
            users[incCard.ResponsibleEmail]["displayName"]
            },<br/><br/>Примите во внимание, что пользователь ${currentUser.displayName
            } завершил расследование инцидента <a href="${siteUrl}${urlDefault}/dashboard/3/incidents-and-nonconformities?incidentCard=${incCard.ID
            }">${incCard.Title.trim()}</a>`,
          DateToBeSentAt: moment().subtract(12, "hours").toDate(),
          Title: "Мои Задачи | Прекращение расследования инцидента",
          Subject: "Мои Задачи | Прекращение расследования инцидента",
          Recepients: incCard.ResponsibleEmail,
          CheckDoc: String(timestamp),
        };
        Promise.all([sendEmail(emailBody)]).then(() => {
          setCustomLoading(false);
          navigate(0);
        });
      } else {
        setCustomLoading(false);
        navigate(0);
      }
    });
  };

  const importPPTXHandleTemp = (typeDownload: string) => {
    if (incCard && Object.keys(incCard).length > 0) {
      if (typeDownload === "file") {
        setPptxLoading(true);
      } else {
        setLoadingEml(true);
      }
      const items = [incCard];
      getItemsRequest({
        listName: myTasksSDCA5WayListName,
        filters: {
          _x0035_Way: ID5Way || 0,
        },
      }).then(async (results) => {
        const sdcaItems = results.items;
        const requests = sdcaItems.map((item: any) =>
          getItemsRequest({
            listName: myTaskActionsListName,
            filters: {
              ImportantHashTag: `#Отчет_об_отклонениях_${item.ID}*`,
            },
          })
        );
        const values = await Promise.all(requests);
        const actions = values.flatMap((value: any) => value.items);
        const rootTree = card5WayTree.filter((item: any) => item.root);
        const rootIndexes = new Map(
          rootTree.map((item: any, index: number) => [
            item.reason.trim(),
            index + 1,
          ])
        );
        const currentSdcaItems = sdcaItems.filter(
          (item: any) => item._x0035_Way.get_lookupId() === ID5Way
        );
        const returnItems: any = items.map((item: any) => {
          const currentActions = currentSdcaItems.flatMap((sdcaItem: any) => {
            return actions
              .filter(
                (action: any) =>
                  action.ImportantHashTag.includes(
                    `#Отчет_об_отклонениях_${sdcaItem.ID}`
                  ) &&
                  !action.ImportantHashTag.includes("A")
              )
              .map((action: any) => ({
                numRoot: rootIndexes.get(sdcaItem.RootTree.trim()) ?? "-",
                sdca: sdcaItem.SDCA.get_lookupValue(),
                description: action.Description,
                date: moment(action.DateForDone).format("DD.MM.YYYY"),
                responsible: users[action.ResponsibleEmail]?.displayName ?? "-",
              }));
          });
          return {
            ...item,
            actions: currentActions,
            currentRootTree: rootTree.length ? rootTree : [],
          };
        });
        let pptxTitle: string = "Инцидент";
        let incCardQuestions: any =
          (incCard.Questions && JSON.parse(incCard.Questions)) || null;
        if (incCard.TypeIncident.ID === incTypes.safe) {
          pptxTitle += `  по безопасности`;
        }
        if (incCard.TypeIncident.ID === incTypes.e) {
          pptxTitle += ` по экологии`;
        }
        if (incCard.TypeIncident.ID === incTypes.q) {
          if (incCardQuestions.QAIncidentType === "Инцидент в процессе") {
            pptxTitle += ` в процессе`;
          }
          if (incCardQuestions.QAIncidentType === "Инцидент по качеству") {
            pptxTitle += ` по качеству`;
          }
        }
        if (incCard.TypeIncident.ID === incTypes.m) {
          pptxTitle += ` по техобслуживанию`;
        }
        let blockClassificationTitle = (incCard.TypeIncident.ID === incTypes.q && "Сорт/Тип продукта/Объем") || "Классификация";
        let blockClassificationRows: SimpleClassificationRow[] | EquipmentClassification = [];
        let blockClassificationType: "simple" | "equipment" = 'simple'
        const keySifType = Object.keys(incCardQuestions).find((key) =>
          key.includes("SafeIncTypeSIF")
        );
        setKeySifTypeEml(keySifType);
        const keyInjuryType = Object.keys(incCardQuestions).find((key) =>
          key.includes("SafeIncInjuryType")
        );
        setKeyInjuryTypeEml(keyInjuryType);
        if (incCard.TypeIncident.ID === incTypes.safe) {
          blockClassificationRows = [
            {
              label: "Классификация инцидента",
              value: (incCardQuestions["SafeIncClassification"] && incCardQuestions["SafeIncClassification"]["name"]) || "-",
            },
            {
              label: "Тип SIF",
              value: keySifType ? incCardQuestions[keySifType] : "-",
            },
            {
              label: "Характер травмы",
              value: keyInjuryType ? incCardQuestions[keyInjuryType] && incCardQuestions[keyInjuryType]['name'] : "-",
            },
            {
              label: "Подкатегория риска",
              value: (incCardQuestions["SafeIncRiskSubcategory"] && incCardQuestions["SafeIncRiskSubcategory"]["name"]) || "-",
            }
          ]
        }
        if (incCard.TypeIncident.ID === incTypes.e) {
          blockClassificationRows = [
            {
              label: "Классификация инцидента",
              value: (incCardQuestions["EnvIncClassification"] && incCardQuestions["EnvIncClassification"]["name"]) || "-",
            },
            {
              label: "Влияние на окружающую среду",
              value: (incCardQuestions["EnvIncValueEnvironment"] && incCardQuestions["EnvIncValueEnvironment"].length > 0 && incCardQuestions["EnvIncValueEnvironment"].join(",")) || "-",
            },
            {
              label: "Относится ли инцидент к SIV?",
              value: incCardQuestions["EnvIncSIVRelated"],
            },
            {
              label: "Нарушение законодательных требований?",
              value: incCardQuestions["EnvIncLegalReq"],
            }
          ]
        }
        if (incCard.TypeIncident.ID === incTypes.q) {
          blockClassificationRows = [
            {
              label: "Сорт/Тип продукта",
              value: incCardQuestions["QAIncidentTypeProduct"],
            },
          ]
          if (incCard.Questions.indexOf("Инцидент в процессе") !== -1) {
            blockClassificationRows = [...blockClassificationRows,
            {
              label: "Объем заблокированной продукции (укажите в Гл или тоннах)",
              value: incCardQuestions["QAIncidentListBlock"],
            },
            ]
          } else {
            blockClassificationRows = [...blockClassificationRows,
            {
              label: "Объем вовлеченной продукции (укажите в Гл или тоннах)",
              value: incCardQuestions["QAIncidentList"],
            },
            ]
          }
        }
        if (incCard.TypeIncident.ID === incTypes.m) {
          blockClassificationType = 'equipment';
          blockClassificationRows = {
            top: [
              {
                label: "Направление",
                value: (incCardQuestions["MIncDirection"] && incCardQuestions["MIncDirection"]["name"]) || "-"
              },
              {
                label: "Тип причины",
                value: (incCardQuestions["MIncReasonType"] && incCardQuestions["MIncReasonType"]["name"]) || "-"
              },
              {
                label: "Время простоя (мин.)",
                value: incCardQuestions["MIncDowntime"]
              }
            ],
            bottom: [
              {
                leftLabel: "SAP номер сообщения",
                leftValue: incCardQuestions["MIncEq"][0]["SAP_MESSAGE"] || "-",
                rightLabel: "Производитель оборудования",
                rightValue: incCardQuestions["MIncEq"][0]["SAP"]["Manufacturer"] || "-"
              },
              {
                leftLabel: "SAP № технического места",
                leftValue: incCardQuestions["MIncEq"][0]["SAP"]["SAP"] || "-",

                rightLabel: "Модель оборудования",
                rightValue: incCardQuestions["MIncEq"][0]["SAP"]["Model"] || "-",
              },
              {
                leftLabel: "Название оборудования",
                leftValue: incCardQuestions["MIncEq"][0]["SAP"]["Title"] || "-",

                rightLabel: "Тип оборудования",
                rightValue: incCardQuestions["MIncEq"][0]["SAP"]["TypeEquipment"] || "-",
              }
            ]
          }
        }
        const pptxParams = {
          incidentNumber: `#${incCard.ID}`,
          incidentUrl: `${siteUrl}/dashboard/3/incidents-and-nonconformities?incidentCard=${incCard.ID}`,
          date: incCard.DateIncidents.format('DD.MM.YYYY'),
          incidentType: pptxTitle.toLocaleUpperCase(),
          location: incCard.Location.Title,
          department: incCard.Department.Title,
          area: incCard.Region.Title,
          initiator: (users[incCard.AuthorEmail] && users[incCard.AuthorEmail]["displayName"]) || "-",
          blockClassificationTitle,
          blockClassificationRows,
          blockClassificationType,
          description: incCard.Description,
          rootCauses: returnItems[0].currentRootTree.map((tree: any) => {
            return {
              description: tree.reason,
              ishikawaCategory: tree.category
            }
          }),
          photos: [],
          actions: returnItems[0].actions.map((action: any) => {
            return {
              description: action.description,
              deadline: action.date,
            }
          })
        }
        const pptx = createIncidentPresentation(pptxParams);
        if (typeDownload === "file") {
          pptx
            .writeFile({ fileName: `${pptxTitle}_${incCard.ID}` })
            .then(() => {
              setPptxLoading(false);
            });
        }
        if (typeDownload === "letter" || typeDownload === "letter-finish") {
          pptx.write({ outputType: "blob" }).then((blob) => {
            const pptxFile = new File(
              [blob],
              `${pptxTitle.replaceAll(" ", "_")}_${incCard.ID}.pptx`,
              {
                type: "application/vnd.openxmlformats-officedocument.presentationml.presentation",
              }
            );
            setModalEml(true);
            setTimeout(() => {
              const elem: any = document.querySelector("#eml_template_inc");
              html2canvas(elem, {
                useCORS: true,
                allowTaint: true,
              }).then(function (canvas) {
                const urlScreen = canvas.toDataURL();
                let QType: any = null;
                if (
                  incCard.TypeIncident.ID === incTypes.q &&
                  incCard.Questions.indexOf("Инцидент в процессе") !== -1
                ) {
                  QType = "Инцидент в процессе";
                }
                if (
                  incCard.TypeIncident.ID === incTypes.q &&
                  incCard.Questions.indexOf("Инцидент по качеству") !== -1
                ) {
                  QType = "Инцидент по качеству";
                }
                getItemsRequest({
                  listName: myTasksIncidentCardRecipientsListName,
                  filters: {
                    Location: incCard.Location.ID,
                    TypeIncident: incCard.TypeIncident.ID,
                    QType,
                  },
                  sortOrder: { name: "ID", desc: true },
                }).then((results) => {
                  const emails =
                    (results.items.length > 0 &&
                      results.items[0]["Recipients"]) ||
                    "";
                  const copies =
                    (results.items.length > 0 &&
                      results.items[0]["Copies"]) ||
                    "";
                  const downloadOutlookFile = async () => {
                    try {
                      await downloadOutlookEmailWithAttachments({
                        from: {
                          name: currentUser.displayName,
                          email: currentUser.email,
                        },
                        to:
                          (typeDownload === "letter" && emails &&
                            emails.split(",").map((email: string) => {
                              return {
                                name: email.trim(),
                                email: email.trim(),
                              };
                            })) ||
                          [],
                        cc:
                          (typeDownload === "letter" && copies &&
                            copies.split(",").map((email: string) => {
                              return {
                                name: email.trim(),
                                email: email.trim(),
                              };
                            })) ||
                          [],
                        subject: (typeDownload === "letter" && (
                          (incCard.Status.ID === incStatus.finish &&
                            `Отчет об инциденте ${titleEmlPptx} - ${incCard.ID}`) ||
                          `Уведомление об инциденте ${titleEmlPptx} - ${incCard.ID}`)) || (typeDownload === "letter-finish" && `Утверждение инцидента ${titleEmlPptx} - ${incCard.ID}`) || '',
                        htmlBody: (typeDownload === "letter" && (
                          (incCard.Status.ID === incStatus.finish &&
                            `<p>Коллеги, здравствуйте! Во вложении отчет об <a href="${siteUrl}/dashboard/3/incidents-and-nonconformities?incidentCard=${incCard.ID}">инциденте ${titleEmlPptx} - ${incCard.ID}</a></p><br/><img src="${urlScreen}" alt=""><br/>`) ||
                          `<p>Коллеги, здравствуйте! Во вложении информация о случившемся <a href="${siteUrl}/dashboard/3/incidents-and-nonconformities?incidentCard=${incCard.ID}">инциденте ${titleEmlPptx} - ${incCard.ID}</a></p><br/><img src="${urlScreen}" alt=""><br/>`)) || (typeDownload === "letter-finish" && `<p>Здравствуйте!<br />Прошу утвердить расследование и завершить в системе <a href="${siteUrl}/dashboard/3/incidents-and-nonconformities?incidentCard=${incCard.ID}">инцидент ${titleEmlPptx} - ${incCard.ID}</a></p><br/><img src="${urlScreen}" alt=""><br/>`) || "",
                        textBody: "",
                        attachments: [
                          {
                            name: `${pptxTitle.replaceAll(" ", "_")}_${incCard.ID
                              }.pptx`,
                            content: pptxFile,
                            mimeType:
                              "application/vnd.openxmlformats-officedocument.presentationml.presentation",
                          },
                        ],
                        fileName: `${pptxTitle.replaceAll(" ", "_")}_${incCard.ID}.eml`,
                      });
                    } catch (error) {
                      console.error("Ошибка:", error);
                    }
                  };
                  downloadOutlookFile().then(() => {
                    setLoadingEml(false);
                    setModalEml(false);
                  });
                });
              });
            }, 5000);
          });
        }
      });
    }
  }

  useEffect(() => {
    setLoadingEml(true);
    if (incCard && Object.keys(incCard).length > 0) {
      let incCardQuestions =
        (incCard.Questions && JSON.parse(incCard.Questions)) || null;
      setIncCardQuestionsEml(incCardQuestions);
      if (incCard.TypeIncident.ID === incTypes.safe) {
        setTitleEmlPptx("по безопасности");
      }
      if (incCard.TypeIncident.ID === incTypes.e) {
        setTitleEmlPptx("по экологии");
      }
      if (incCard.TypeIncident.ID === incTypes.q) {
        if (incCardQuestions.QAIncidentType === "Инцидент в процессе") {
          setTitleEmlPptx("в процессе");
        }
        if (incCardQuestions.QAIncidentType === "Инцидент по качеству") {
          setTitleEmlPptx("по качеству");
        }
      }
      if (incCard.TypeIncident.ID === incTypes.m) {
        setTitleEmlPptx("по техобслуживанию");
      }
      if (ID5Way) {
        getItemsRequest({
          listName: myTasksSDCA5WayListName,
          filters: { _x0035_Way: ID5Way },
        })
          .then((results) => {
            const sdcaItems = [...results.items];
            let arrRequests: any = [];
            sdcaItems.map((item) => {
              arrRequests = [
                ...arrRequests,
                getItemsRequest({
                  listName: myTaskActionsListName,
                  filters: {
                    ImportantHashTag: `#Отчет_об_отклонениях_${item.ID}*`,
                  },
                }),
              ];
            });
            if (arrRequests.length > 0) {
              Promise.all(arrRequests)
                .then((values) => {
                  let actions: any = [];
                  values.map((value) => {
                    actions = [...actions, ...value.items];
                    const currentSdcaItems = sdcaItems.filter(
                      (sdcaItem: any) =>
                        sdcaItem._x0035_Way.get_lookupId() === ID5Way
                    );
                    let currentActions: any = [];
                    currentSdcaItems.map((currentSdcaItem: any) => {
                      currentActions = [
                        ...currentActions,
                        ...actions
                          .filter(
                            (action: any) =>
                              action.ImportantHashTag.indexOf(
                                `#Отчет_об_отклонениях_${currentSdcaItem.ID}`
                              ) !== -1 && action.ImportantHashTag.indexOf('A') === -1
                          )
                          .map((action: any, idx: number) => {
                            return {
                              idx: idx + 1,
                              description: action.Description,
                              date: moment(action.DateForDone).format(
                                "DD.MM.YYYY"
                              ),
                            };
                          }),
                      ];
                    });
                    setActionsEml([...currentActions]);
                    setLoadingEml(false);
                  });
                })
                .catch((error) => {
                  console.error("Ошибка:", error);
                  setLoadingEml(false);
                });
            } else {
              setLoadingEml(false);
            }
          })
          .catch((error) => {
            console.error("Ошибка:", error);
            setLoadingEml(false);
          });
      } else {
        setLoadingEml(false);
      }
    } else if (incCardStatus === "SUCCESS") {
      setLoadingEml(false);
    }
  }, [incCard, ID5Way]);

  useEffect(() => {
    if (
      incCard &&
      Object.keys(incCard).length > 0 &&
      currentUser.email &&
      !incCard.View &&
      incCard.ResponsibleEmail.indexOf(currentUser.email) !== -1
    ) {
      setCustomLoading(true);
      updateItemRequest({
        listName: myTasksIncidentstListName,
        body: { ID: incCard.ID, View: true },
      }).then(() => {
        setCustomLoading(false);
      });
    }
  }, [incCard, currentUser]);

  return (
    <>
      <DrawerComponent zIndex={zIndex} open={open} toggleDrawer={setOpen}>
        <div className="flex flex-col p-10 shrink">
          {customLoading && <LoadingOpBg />}
          {incCard && Object.keys(incCard).length > 0 && (
            <>
              <FlexRow className="justify-between gap-5 mb-8">
                <h1 className="mb-8 text-black relative break-words z-[3]">
                  {incCard.Title}
                </h1>
                <FlexCol className="gap-2">
                  <FlexRow className="gap-[10px]">
                    {<Statuses incidentID={incidentID} />}
                    {JSON.parse(incCard.Questions)["IncidentOption"] ===
                      "Инцидент" && (
                        <>
                          {((loadingEml || statusUsers === "LOADING") && (
                            <FlexCol className="h-[32px] w-[32px]">
                              <Loading />
                            </FlexCol>
                          )) || (
                              <>
                                {incCard.Status.ID !== incStatus.finish &&
                                  incCard.Status.ID !== incStatus.cancel &&
                                  (card5WayTree.some((treeItem: any) => treeItem.root) && actionsEml.length > 0) &&
                                  <TooltipItem
                                    position="top-left"
                                    tooltipsText={"Сформировать письмо для утверждения инцидента"}
                                  >
                                    <a
                                      href="#"
                                      onClick={(e) => {
                                        e.preventDefault();
                                        importPPTXHandleTemp("letter-finish");
                                      }}
                                      className="flex w-6 h-6 text-[#9CA3AF] hover:text-[#012169]"
                                    >
                                      <LetterFinish />
                                    </a>
                                  </TooltipItem>
                                }
                                <TooltipItem
                                  position="top-left"
                                  tooltipsText={
                                    (incCard.Status.ID === incStatus.finish &&
                                      "Скачать письмо о результатах расследования инцидента") ||
                                    "Скачать письмо о случившемся инциденте"
                                  }
                                >
                                  <a
                                    href="#"
                                    onClick={(e) => {
                                      e.preventDefault();
                                      importPPTXHandleTemp("letter");
                                    }}
                                    className="flex w-6 h-6 text-[#9CA3AF] hover:text-[#012169]"
                                  >
                                    <Letter />
                                  </a>
                                </TooltipItem>
                              </>
                            )}
                          {((pptxLoading || statusUsers === "LOADING") && (
                            <FlexCol className="h-[32px] w-[32px]">
                              <Loading />
                            </FlexCol>
                          )) || (
                              <TooltipItem
                                position="top-left"
                                tooltipsText="Скачать в Power Point"
                              >
                                <a
                                  href="#"
                                  onClick={(e) => {
                                    e.preventDefault();
                                    importPPTXHandleTemp("file");
                                  }}
                                  className="flex w-6 h-6 text-[#9CA3AF] hover:text-[#012169]"
                                >
                                  <DownloadWithHoverIcon />
                                </a>
                              </TooltipItem>
                            )}
                        </>
                      )}
                    {(currentUser.isAdmin ||
                      (currentUser.isLocationEditorMyTasks &&
                        currentUser.isLocationEditorMyTasks.length > 0 &&
                        currentUser.isLocationEditorMyTasks.find(
                          (locationID: any) => locationID === incCard.Location.ID
                        )) ||
                      (currentUser.isLocationAdminMyTasks &&
                        currentUser.isLocationAdminMyTasks.length > 0 &&
                        currentUser.isLocationAdminMyTasks.find(
                          (locationID: any) => locationID === incCard.Location.ID
                        ))) &&
                      incCard.Status.ID !== incStatus.cancel && (
                        <TooltipItem
                          position="top-left"
                          tooltipsText={
                            (JSON.parse(incCard.Questions)["IncidentOption"] ===
                              "Несоответствие" &&
                              "Отменить несоответствие") ||
                            "Отменить инцидент"
                          }
                        >
                          <a
                            href="#"
                            onClick={(e) => {
                              e.preventDefault();
                              setCancelModal(true);
                            }}
                            className="flex w-6 h-6 text-[#9CA3AF] hover:text-[#012169]"
                          >
                            <CancelIcon />
                          </a>
                        </TooltipItem>
                      )}
                    {currentUser.incidentAdmin && (
                      <TooltipItem
                        position="top-left"
                        tooltipsText={
                          (JSON.parse(incCard.Questions)["IncidentOption"] ===
                            "Несоответствие" &&
                            "Удалить несоответствие") ||
                          "Удалить инцидент"
                        }
                      >
                        <a
                          href="#"
                          onClick={(e) => {
                            e.preventDefault();
                            setRemoveModal(true);
                          }}
                          className="flex w-6 h-6 text-[#9CA3AF] hover:text-[#012169]"
                        >
                          <Trash />
                        </a>
                      </TooltipItem>
                    )}
                  </FlexRow>
                  {incCard.Status.ID === 17 && incCard.UserFinished &&
                    <div className="min-w-[320px] max-w-[320px] rounded-lg border p-2 bg-white border-[#DFE4EA]">
                      <span className="font-medium mb-2 block text-sm text-[#F89090]">Этот инцидент завершил(а):</span>
                      <div className="flex gap-2">
                        <UserAvatar
                          avatar={users[incCard.UserFinished] && users[incCard.UserFinished].avatar}
                          shortName={users[incCard.UserFinished] && users[incCard.UserFinished]['shortName']}
                          displayName={users[incCard.UserFinished] && users[incCard.UserFinished].displayName}
                          email={incCard.UserFinished}
                        />
                        <FlexCol className="justify-center items-start">
                          <span className="text-[#111928]">{users[incCard.UserFinished] && users[incCard.UserFinished].displayName}</span>
                          <span className="text-sm text-[#637381]" dangerouslySetInnerHTML={{ __html: users[incCard.UserFinished] && users[incCard.UserFinished]['jobTitle'] }} />
                          {incCard.DateFinished && <span className="text-sm text-[#637381]">{incCard.DateFinished.format('DD.MM.YYYY')}</span>}
                        </FlexCol>
                      </div>
                    </div>
                  }
                </FlexCol>
              </FlexRow>
              <Form
                type="inc_card_my_tasks"
                setFormData={setFormData}
                setCurrentTypeInc={setCurrentTypeInc}
                setCurrentFormData={setCurrentFormData}
                fieldsForm={[...fields]}
                defaultValues={defaultValues}
                setCard5WayTree={setCard5WayTree}
                setDependenceFields={setDependenceFields}
                incidentID={incidentID}
                card5WayTree={card5WayTree}
                ID5WayAdd={ID5Way}
                incLoading={customLoading}
                setInvCompletedModal={setInvCompletedModal}
                incCard={incCard}
                actionsEml={actionsEml}
              />
              {(incCard.Status.ID === incStatus.finish ||
                incCard.Status.ID === incStatus.cancel) && (
                  <FlexRow className="justify-between w-full gap-5">
                    <Button
                      classBg="btn-white"
                      shadow={true}
                      text="Закрыть"
                      open={open}
                      setOpen={setOpen}
                    />
                    {(currentUser.isAdmin ||
                      (currentUser.isDirecor &&
                        incCard.Status.ID === incStatus.finish) ||
                      (incCard.Status.ID === incStatus.cancel &&
                        ((currentUser.isLocationEditorMyTasks &&
                          currentUser.isLocationEditorMyTasks.length > 0 &&
                          currentUser.isLocationEditorMyTasks.find(
                            (locationID: any) =>
                              locationID === incCard.Location.ID
                          )) ||
                          (currentUser.isLocationAdminMyTasks &&
                            currentUser.isLocationAdminMyTasks.length > 0 &&
                            currentUser.isLocationAdminMyTasks.find(
                              (locationID: any) =>
                                locationID === incCard.Location.ID
                            ))))) && (
                        <Button
                          open={returnToWorkModal}
                          setOpen={setReturnToWorkModal}
                          classBg="btn-dark"
                          icon={true}
                          typeIcon="return"
                          shadow={true}
                          text="Вернуть в работу"
                        />
                      )}
                  </FlexRow>
                )}
            </>
          )}
        </div>
      </DrawerComponent>
      <Modal
        zIndex={zIndex ? zIndex + 10 : 70}
        modalClassName="min-h-px"
        open={cancelModal}
        toggleDialog={setCancelModal}
      >
        <header className="px-10 pb-4">
          <h2>Подтвердите действие</h2>
        </header>

        <div className="px-10 py-5">
          {(incCard &&
            Object.keys(incCard).length > 0 &&
            JSON.parse(incCard.Questions)["IncidentOption"] ===
            "Несоответствие" && (
              <p>Вы уверены, что хотите отменить несоответствие?</p>
            )) || <p>Вы уверены, что хотите отменить инцидент?</p>}
        </div>
        <footer className="flex justify-between w-full px-10 pt-10 mt-4 border-t">
          <TGButton color="white" onClick={(e) => setCancelModal(!cancelModal)}>
            Не отменять
          </TGButton>
          <TGButton color="bluedark" onClick={cancelHandle}>
            Да, отменить
          </TGButton>
        </footer>
      </Modal>
      <Modal
        zIndex={zIndex ? zIndex + 10 : 70}
        modalClassName="min-h-px"
        open={removeModal}
        toggleDialog={setRemoveModal}
      >
        <header className="px-10 pb-4">
          <h2>Подтвердите действие</h2>
        </header>

        <div className="px-10 py-5">
          {(incCard &&
            Object.keys(incCard).length > 0 &&
            JSON.parse(incCard.Questions)["IncidentOption"] ===
            "Несоответствие" && (
              <p>Вы уверены, что хотите удалить несоответствие?</p>
            )) || <p>Вы уверены, что хотите удалить инцидент?</p>}
        </div>
        <footer className="flex justify-between w-full px-10 pt-10 mt-4 border-t">
          <TGButton color="white" onClick={(e) => setRemoveModal(!removeModal)}>
            Не удалять
          </TGButton>
          <TGButton color="bluedark" onClick={removeHandle}>
            Да, удалить
          </TGButton>
        </footer>
      </Modal>
      <Modal
        zIndex={zIndex ? zIndex + 10 : 70}
        modalClassName="min-h-px"
        open={returnToWorkModal}
        toggleDialog={setReturnToWorkModal}
      >
        <header className="px-10 pb-4">
          <h2>Подтвердите действие</h2>
        </header>
        <div className="px-10 py-5">
          {(incCard &&
            Object.keys(incCard).length > 0 &&
            JSON.parse(incCard.Questions)["IncidentOption"] ===
            "Несоответствие" && (
              <p>Вы уверены, что хотите вернуть в работу несоответствие?</p>
            )) || <p>Вы уверены, что хотите вернуть в работу инцидент?</p>}
        </div>
        <footer className="flex justify-between w-full px-10 pt-10 mt-4 border-t">
          <TGButton
            color="white"
            onClick={(e) => setReturnToWorkModal(!returnToWorkModal)}
          >
            Не возвращать
          </TGButton>
          <TGButton
            color="bluedark"
            onClick={(e) =>
              returnToWorkHandle(
                incCard &&
                Object.keys(incCard).length > 0 &&
                JSON.parse(incCard.Questions)["IncidentOption"]
              )
            }
          >
            Да, вернуть
          </TGButton>
        </footer>
      </Modal>
      <Modal
        zIndex={zIndex ? zIndex + 10 : 70}
        modalClassName="min-h-px"
        open={invCompletedModal}
        toggleDialog={setInvCompletedModal}
      >
        <header className="px-10 pb-4">
          <h2>Подтвердите действие</h2>
        </header>

        <div className="px-10 py-5">
          <p>Завершить расследование инцидента?</p>
        </div>
        <footer className="flex justify-between w-full px-10 pt-10 mt-4 border-t">
          <TGButton
            color="white"
            onClick={(e) => setInvCompletedModal(!invCompletedModal)}
          >
            Отмена
          </TGButton>
          <TGButton color="bluedark" onClick={invCompletedHandle}>
            Да, завершить
          </TGButton>
        </footer>
      </Modal>
      <Modal
        zIndex={zIndex ? zIndex + 10 : 70}
        modalClassName="min-h-px"
        open={modalEml}
        toggleDialog={setModalEml}
      >
        <FlexCol className="items-center justify-center w-full">
          <span className="block mb-5 text-base text-darkblue">
            Формируем письмо...
          </span>
          <Loading />
        </FlexCol>
        {incCard &&
          Object.keys(incCard).length > 0 &&
          incCardQuestionsEml &&
          fields.length > 0 && (
            <FlexCol className="p-[25px] overflow-auto scrollbar scrollbar-thumb-rounded-lg scrollbar-h-2 scrollbar-w-2 scrollbar-thumb-[#D1D5DB] max-w-[700px] h-[350px]">
              <FlexCol
                id="eml_template_inc"
                className="border border-[#004465] min-w-[1920px]"
              >
                {/* Верхняя строка: номер + дата + заголовок над «Описание» */}
                <div className="grid grid-cols-1 md:grid-cols-2 bg-blue-800 text-white text-sm font-medium">
                  <div className="flex items-center gap-6 px-4 py-2">
                    <span>#{incCard.ID}</span>
                    <span>{incCard.DateIncidents.format('DD.MM.YYYY')}</span>
                  </div>
                  <div className="flex items-center justify-center px-4 py-2 uppercase tracking-wide">
                    {`инцидент ${titleEmlPptx}`.toLocaleUpperCase()}
                  </div>
                </div>

                {/* Локация + Описание */}
                <div className="grid grid-cols-1 md:grid-cols-2">
                  <div className="flex items-center justify-center bg-blue-800 text-white text-center py-1.5 text-sm font-semibold">
                    Локация
                  </div>
                  <div className="flex items-center justify-center bg-blue-800 text-white text-center py-1.5 text-sm font-semibold">
                    Описание
                  </div>
                </div>
                <div className="grid grid-cols-1 md:grid-cols-2">
                  {/* Левая колонка: Локация */}
                  <div className="border-r border-gray-300">
                    <table className="w-full text-sm">
                      <tr className="border-b border-gray-200">
                        <td className="w-40 bg-gray-50 px-3 py-2 font-medium text-gray-700 border-r border-gray-200">Локация:</td>
                        <td className="px-3 py-2">{incCard.Location.Title}</td>
                      </tr>
                      <tr className="border-b border-gray-200">
                        <td className="bg-gray-50 px-3 py-2 font-medium text-gray-700 border-r border-gray-200">Отдел:</td>
                        <td className="px-3 py-2">{incCard.Department.Title}</td>
                      </tr>
                      <tr className="border-b border-gray-200">
                        <td className="bg-gray-50 px-3 py-2 font-medium text-gray-700 border-r border-gray-200">Участок:</td>
                        <td className="px-3 py-2">{incCard.Region.Title}</td>
                      </tr>
                      <tr>
                        <td className="bg-gray-50 px-3 py-2 font-medium text-gray-700 border-r border-gray-200">ФИО инициатора:</td>
                        <td className="px-3 py-2">{(users[incCard.AuthorEmail] && users[incCard.AuthorEmail]["displayName"]) || "-"}</td>
                      </tr>
                    </table>
                  </div>

                  {/* Правая колонка: Описание */}
                  <div>
                    <div className="p-3 text-sm leading-relaxed">
                      {incCard.Description}
                    </div>
                  </div>
                </div>

                {/* Классификация + Корневые причины */}
                <div className="grid grid-cols-1 md:grid-cols-2 border-t border-gray-300">
                  {/* Левая колонка: Классификация */}
                  <div className="border-r border-gray-300">
                    <div className="flex items-center justify-center bg-blue-800 text-white text-center py-1.5 text-sm font-semibold">
                      {(incCard.TypeIncident.ID === incTypes.q && "Сорт/Тип продукта/Объем") || "Классификация"}
                    </div>
                    {incCard.TypeIncident.ID === incTypes.m &&
                      <table className="w-full text-sm">
                        <tr className="border-b border-gray-200">
                          <td className="w-40 bg-gray-50 px-3 py-2 font-medium text-gray-700 border-r border-gray-200">Направление</td>
                          <td className="px-3 py-2">{(incCardQuestionsEml["MIncDirection"] && incCardQuestionsEml["MIncDirection"]["name"]) || "-"}</td>
                        </tr>
                        <tr className="border-b border-gray-200">
                          <td className="bg-gray-50 px-3 py-2 font-medium text-gray-700 border-r border-gray-200">Тип причины</td>
                          <td className="px-3 py-2">{(incCardQuestionsEml["MIncReasonType"] && incCardQuestionsEml["MIncReasonType"]["name"]) || "-"}</td>
                        </tr>
                        <tr className="border-b border-gray-200">
                          <td className="bg-gray-50 px-3 py-2 font-medium text-gray-700 border-r border-gray-200">Время простоя (мин.)</td>
                          <td className="px-3 py-2 font-semibold">{incCardQuestionsEml["MIncDowntime"]}</td>
                        </tr>
                      </table>
                    }
                    {incCard.TypeIncident.ID === incTypes.q &&
                      <table className="w-full text-sm">
                        <tr className="border-b border-gray-200">
                          <td className="w-40 bg-gray-50 px-3 py-2 font-medium text-gray-700 border-r border-gray-200">Сорт/Тип продукта</td>
                          <td className="px-3 py-2">{incCardQuestionsEml["QAIncidentTypeProduct"]}</td>
                        </tr>
                        {incCard.Questions.indexOf("Инцидент в процессе") !== -1 &&
                          <tr className="border-b border-gray-200">
                            <td className="bg-gray-50 px-3 py-2 font-medium text-gray-700 border-r border-gray-200">Объем заблокированной продукции (укажите в Гл или тоннах)</td>
                            <td className="px-3 py-2">{incCardQuestionsEml["QAIncidentListBlock"]}</td>
                          </tr> ||
                          <tr className="border-b border-gray-200">
                            <td className="bg-gray-50 px-3 py-2 font-medium text-gray-700 border-r border-gray-200">Объем вовлеченной продукции (укажите в Гл или тоннах)</td>
                            <td className="px-3 py-2">{incCardQuestionsEml["QAIncidentList"]}</td>
                          </tr>
                        }
                      </table>
                    }
                    {incCard.TypeIncident.ID === incTypes.e &&
                      <table className="w-full text-sm">
                        <tr className="border-b border-gray-200">
                          <td className="w-40 bg-gray-50 px-3 py-2 font-medium text-gray-700 border-r border-gray-200">Классификация инцидента</td>
                          <td className="px-3 py-2">{(incCardQuestionsEml["EnvIncClassification"] && incCardQuestionsEml["EnvIncClassification"]["name"]) || "-"}</td>
                        </tr>
                        <tr className="border-b border-gray-200">
                          <td className="bg-gray-50 px-3 py-2 font-medium text-gray-700 border-r border-gray-200">Влияние на окружающую среду</td>
                          <td className="px-3 py-2">{(incCardQuestionsEml["EnvIncValueEnvironment"] && incCardQuestionsEml["EnvIncValueEnvironment"].length > 0 && incCardQuestionsEml["EnvIncValueEnvironment"].join(",")) || "-"}</td>
                        </tr>
                        <tr className="border-b border-gray-200">
                          <td className="bg-gray-50 px-3 py-2 font-medium text-gray-700 border-r border-gray-200">Относится ли инцидент к SIV?</td>
                          <td className="px-3 py-2 font-semibold">{incCardQuestionsEml["EnvIncSIVRelated"]}</td>
                        </tr>
                        <tr className="border-b border-gray-200">
                          <td className="bg-gray-50 px-3 py-2 font-medium text-gray-700 border-r border-gray-200">Нарушение законодательных требований?</td>
                          <td className="px-3 py-2 font-semibold">{incCardQuestionsEml["EnvIncLegalReq"]}</td>
                        </tr>
                      </table>
                    }
                    {incCard.TypeIncident.ID === incTypes.safe &&
                      <table className="w-full text-sm">
                        <tr className="border-b border-gray-200">
                          <td className="w-40 bg-gray-50 px-3 py-2 font-medium text-gray-700 border-r border-gray-200">Классификация инцидента</td>
                          <td className="px-3 py-2">{(incCardQuestionsEml["SafeIncClassification"] && incCardQuestionsEml["SafeIncClassification"]["name"]) || "-"}</td>
                        </tr>
                        <tr className="border-b border-gray-200">
                          <td className="bg-gray-50 px-3 py-2 font-medium text-gray-700 border-r border-gray-200">Тип SIF</td>
                          <td className="px-3 py-2">{keySifTypeEml ? incCardQuestionsEml[keySifTypeEml] : "-"}</td>
                        </tr>
                        <tr className="border-b border-gray-200">
                          <td className="bg-gray-50 px-3 py-2 font-medium text-gray-700 border-r border-gray-200">Характер травмы</td>
                          <td className="px-3 py-2 font-semibold">{keyInjuryTypeEml ? incCardQuestionsEml[keyInjuryTypeEml] && incCardQuestionsEml[keyInjuryTypeEml]["name"] : "-"}</td>
                        </tr>
                        <tr className="border-b border-gray-200">
                          <td className="bg-gray-50 px-3 py-2 font-medium text-gray-700 border-r border-gray-200">Подкатегория риска</td>
                          <td className="px-3 py-2 font-semibold">{(incCardQuestionsEml["SafeIncRiskSubcategory"] && incCardQuestionsEml["SafeIncRiskSubcategory"]["name"]) || "-"}</td>
                        </tr>
                      </table>
                    }
                    {/* SAP и оборудование */}
                    {incCard.TypeIncident.ID === incTypes.m &&
                      <table className="w-full table-fixed text-sm border-t border-gray-200">
                        <tr className="border-b border-gray-200">
                          <td className="w-1/4 bg-gray-50 px-3 py-2 font-medium text-gray-700 border-r border-gray-200">
                            SAP номер сообщения
                          </td>
                          <td className="w-1/4 px-3 py-2">
                            {incCardQuestionsEml["MIncEq"] && Array.isArray(incCardQuestionsEml["MIncEq"]) && incCardQuestionsEml["MIncEq"][0]["SAP_MESSAGE"] || "-"}
                          </td>
                          <td className="w-1/4 bg-gray-50 px-3 py-2 font-medium text-gray-700 border-l border-r border-gray-200">
                            Производитель оборудования
                          </td>
                          <td className="w-1/4 px-3 py-2">
                            {incCardQuestionsEml["MIncEq"] && Array.isArray(incCardQuestionsEml["MIncEq"]) && incCardQuestionsEml["MIncEq"][0]["SAP"]["Manufacturer"] || "-"}
                          </td>
                        </tr>
                        <tr className="border-b border-gray-200">
                          <td className="w-1/4 bg-gray-50 px-3 py-2 font-medium text-gray-700 border-r border-gray-200">
                            SAP № технического места
                          </td>
                          <td className="w-1/4 px-3 py-2">
                            {incCardQuestionsEml["MIncEq"] && Array.isArray(incCardQuestionsEml["MIncEq"]) && incCardQuestionsEml["MIncEq"][0]["SAP"]["SAP"] || "-"}
                          </td>
                          <td className="w-1/4 bg-gray-50 px-3 py-2 font-medium text-gray-700 border-l border-r border-gray-200">
                            Модель оборудования
                          </td>
                          <td className="w-1/4 px-3 py-2">
                            {incCardQuestionsEml["MIncEq"] && Array.isArray(incCardQuestionsEml["MIncEq"]) && incCardQuestionsEml["MIncEq"][0]["SAP"]["Model"] || "-"}
                          </td>
                        </tr>
                        <tr>
                          <td className="w-1/4 bg-gray-50 px-3 py-2 font-medium text-gray-700 border-r border-gray-200">
                            Название оборудования
                          </td>
                          <td className="w-1/4 px-3 py-2">
                            {incCardQuestionsEml["MIncEq"] && Array.isArray(incCardQuestionsEml["MIncEq"]) && incCardQuestionsEml["MIncEq"][0]["SAP"]["Title"] || "-"}
                          </td>
                          <td className="w-1/4 bg-gray-50 px-3 py-2 font-medium text-gray-700 border-l border-r border-gray-200">
                            Тип оборудования
                          </td>
                          <td className="w-1/4 px-3 py-2">
                            {incCardQuestionsEml["MIncEq"] && Array.isArray(incCardQuestionsEml["MIncEq"]) && incCardQuestionsEml["MIncEq"][0]["SAP"]["TypeEquipment"] || "-"}
                          </td>
                        </tr>
                      </table>
                    }
                  </div>

                  {/* Правая колонка: Корневые причины */}
                  <div>
                    <div className="flex items-center justify-center bg-blue-800 text-white text-center py-1.5 text-sm font-semibold">
                      Корневые причины
                    </div>
                    <table className="w-full text-sm">
                      <thead>
                        <tr className="bg-gray-100 border-b border-gray-300">
                          <th className="px-2 py-1.5 text-left font-semibold w-10">№</th>
                          <th className="px-2 py-1.5 text-left font-semibold">Описание</th>
                          <th className="px-2 py-1.5 text-left font-semibold w-28">Категория Ишикавы</th>
                        </tr>
                      </thead>
                      <tbody>
                        {card5WayTree.filter((tree: any) => tree.root).map((tree: any, idx: number) => (
                          <tr>
                            <td className="px-2 py-2 border-b border-gray-200 align-top">{idx + 1}</td>
                            <td className="px-2 py-2 border-b border-gray-200">{tree.reason}</td>
                            <td className="px-2 py-2 border-b border-gray-200">{tree.category}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>

                {/* Фото + Действия */}
                <div className="grid grid-cols-1 md:grid-cols-2 border-t border-gray-300">
                  {/* Левая колонка: Фото */}
                  <div className="border-r border-gray-300 min-h-[220px]">
                    <div className="flex items-center justify-center bg-blue-800 text-white text-center py-1.5 text-sm font-semibold">
                      Фото
                    </div>
                    <div className="h-48 flex items-center justify-center text-gray-400 text-sm">
                      {/* место под фото */}
                    </div>
                  </div>

                  {/* Правая колонка: Действия */}
                  <div>
                    <div className="flex items-center justify-center bg-blue-800 text-white text-center py-1.5 text-sm font-semibold">
                      Действия
                    </div>
                    <table className="w-full text-sm">
                      <thead>
                        <tr className="bg-gray-100 border-b border-gray-300">
                          <th className="px-2 py-1.5 text-left font-semibold w-8">№</th>
                          <th className="px-2 py-1.5 text-left font-semibold">Описание</th>
                          <th className="px-2 py-1.5 text-left font-semibold w-24">Срок</th>
                        </tr>
                      </thead>
                      <tbody>
                        {actionsEml.map((action: any, idx: number) => (
                          <tr className="border-b border-gray-200">
                            <td className="px-2 py-2 align-top">{idx + 1}</td>
                            <td className="px-2 py-2">{action.description}</td>
                            <td className="px-2 py-2 whitespace-nowrap">{action.date}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </FlexCol>
            </FlexCol>
          )}
      </Modal>
    </>
  );
};

export default IncidentCard;
